'use client';
import React from 'react';
import { FC, ReactElement } from 'react';

const FormCard:FC<{children: ReactElement, id?: string}> = ({children, id}) => {
    return <div id={id} className="relative bg-base-grey-2 rounded-4xl p-16 pt-0 min-h-full">
        {children}
    </div>
};

export default FormCard;